window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.Popper = require("popper.js").default;
  window.$ = window.jQuery = require("jquery");
  window.Cropper = require("../../../node_modules/cropperjs/dist/cropper.js");
  window.URI = require("urijs");
  window.moment = require("moment");
  window.mitt = require("mitt").default;
  window.emitter = window.mitt();
  window.AlertService = require("../services/AlertService").default;
  window.AlertService2 = require("../services/AlertService2").default;
  window.LoadingService = require("../services/LoadingService").default;
  window.uuidv4 = require("uuid").v4;
  window.converteData = require("../services/StringUtilService").converteData;
  window.converteDataHora =
    require("../services/StringUtilService").converteDataHora;
  window.numeroToNumber =
    require("../services/StringUtilService").numeroToNumber;
  window.sleep = require("../services/sleep").default;
} catch (e) {
  console.error(e);
}

require("./axios");

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

require("moment/locale/pt-br");
require("moment/locale/pt");
require("../../../node_modules/tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4.js");
require("../../../node_modules/bootstrap/dist/js/bootstrap");
require("../../../node_modules/string-mask/src/string-mask.js");
require("../../../node_modules/angular/angular.js");
require("../../../node_modules/angular-sanitize/angular-sanitize.js");
require("../../../resources/assets/vendor/plugins/chosen-js/chosen.jquery.js");
require("../../../node_modules/angular-chosen-localytics/dist/angular-chosen.min.js");
require("jquery-ui");
require("jquery-ui/ui/widgets/mouse");
require("jquery-ui/ui/widgets/sortable");
require("../../../public/bower_components/jqueryui-touch-punch/jquery.ui.touch-punch.js");
require("../../../node_modules/angular-ui-sortable/dist/sortable.js");
require("../../../resources/assets/js/restrito/angular-js/app.js");
require("../../../node_modules/angular-recaptcha/release/angular-recaptcha.min.js");
require("../../../resources/assets/js/angular-js/custom/filters.js");
require("../../../resources/assets/js/angular-js/custom/directives.js");
require("../../../resources/assets/js/angular-js/custom/directives/angucomplete-mini-crud-pessoas.js");
require("../../../resources/assets/js/angular-js/custom/directives/campanha-galeria.js");
require("../../../resources/assets/js/angular-js/custom/directives/campanha-valores-sugeridos-directive.js");
require("../../../resources/assets/js/angular-js/custom/directives/filtro-campanhas-directive.js");
require("../../../resources/assets/js/angular-js/custom/directives/filtro-campanhas-politicas-directive.js");
require("../../../resources/assets/js/angular-js/custom/directives/filtro-doacoes-directive.js");
require("../../../resources/assets/js/angular-js/custom/directives/forma-pagamento-directive.js");
require("../../../resources/assets/js/angular-js/custom/directives/modal-estornar-movimentacao.js");
require("../../../resources/assets/js/angular-js/custom/directives/modal-galeria.js");
require("../../../resources/assets/js/angular-js/custom/directives/notificacoes.js");
require("../../../resources/assets/js/angular-js/custom/directives/permissao.js");
require("../../../resources/assets/js/angular-js/custom/directives/qrcode-generator-directive.js");
require("../../../resources/assets/js/angular-js/custom/directives/recados.js");
require("../../../resources/assets/js/angular-js/custom/directives/selecao-empresa.js");
require("../../../resources/assets/js/angular-js/custom/directives/select-fontawesome.js");
require("../../../resources/assets/js/angular-js/custom/directives/usuario-endereco-directive.js");
require("../../../resources/assets/js/angular-js/custom/directives/variaveis-template.js");
require("../../../resources/assets/js/angular-js/custom/directives/whatsapp-link.js");
require("../../../resources/assets/js/angular-js/custom/selects/select-banco.js");
require("../../../resources/assets/js/angular-js/custom/selects/select-cargo.js");
require("../../../resources/assets/js/angular-js/custom/selects/select-causa.js");
require("../../../resources/assets/js/angular-js/custom/selects/select-municipio.js");
require("../../../resources/assets/js/angular-js/custom/selects/select-partido.js");
require("../../../resources/assets/js/angular-js/custom/selects/select-uf.js");
require("../../../resources/assets/js/angular-js/custom/selects/select-usuario.js");
require("../../../resources/assets/js/restrito/HttpInterceptors.js");
require("../../../resources/assets/vendor/plugins/gritter/js/jquery.gritter.min.js");
require("../../../resources/assets/vendor/plugins/qrcodejs/qrcode.min.js");
require("ui-bootstrap4");
require("../../../node_modules/angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min.js");
require("../../../resources/assets/vendor/plugins/summernote/summernote-bs4.min.js");
require("../../../resources/assets/vendor/plugins/summernote/lang/summernote-pt-BR.min.js");
require("../../../resources/assets/vendor/plugins/jquery-price_format/jquery.price_format.js");
require("../../../node_modules/angular-summernote/dist/angular-summernote.min.js");
require("../../../node_modules/ng-file-upload/dist/ng-file-upload.min.js");
require("../../../node_modules/urijs/src/URI.min.js");
require("../../../node_modules/jquery-mask-plugin/dist/jquery.mask.js");
require("../../../resources/assets/vendor/plugins/jquery-maskmoney/jquery.maskMoney.js");
require("../../../resources/assets/vendor/plugins/angular/ng-mask/ngMask.min.js");
require("../../../resources/assets/vendor/plugins/angular/angular-timeago/angular-timeago.min.js");
require("../../../resources/assets/vendor/bower_components/angular-ui-calendar/src/calendar.js");
require("../../../resources/assets/vendor/plugins/tpruvot/fullcalendar/dist/fullcalendar.js");
require("../../../resources/assets/vendor/plugins/tpruvot/fullcalendar/dist/lang/pt-br.js");
require("../../../resources/assets/vendor/bower_components/simple-angucomplete-alt/simple-angucomplete-alt.js");
require("../../../resources/assets/vendor/bower_components/angucomplete-alt/dist/angucomplete-alt.min.js");
require("../../../public/bower_components/select2/dist/js/select2.min.js");
require("../../../public/bower_components/angular-ui-select2/src/select2.js");
require("../../../public/bower_components/bootstrap-toggle/js/bootstrap-toggle.min.js");
require("../../../public/bower_components/angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min.js");
require("../../../node_modules/ng-tags-input/build/ng-tags-input.js");
require("../../../node_modules/owl.carousel/dist/owl.carousel.min.js");
require("../../../resources/assets/js/site/cadastro.js");
require("../../../resources/assets/js/site/campanhas.doar.js");
require("../../../resources/assets/js/site/campanhas.doar.sucesso.js");
require("../../../resources/assets/js/site/campanhas.index.js");
require("../../../resources/assets/js/site/campanhas.show.js");
require("../../../resources/assets/js/site/doacoes.js");
require("../../../resources/assets/js/site/doisfatores.js");
require("../../../resources/assets/js/site/fale-conosco.js");
require("../../../resources/assets/js/site/home.js");
require("../../../resources/assets/js/site/login.js");
require("../../../public/vendor/rafwell/simple-grid/js/simplegrid.js");
require("../../../resources/assets/js/restrito/basico.js");
